import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.background,
        borderRadius: theme.borderRadius,
        border: theme.border,
        padding: 8,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.tertiary
        }
    },
    rootDisabled: {
        backgroundColor: theme.background,
        borderRadius: theme.borderRadius,
        border: theme.border,
        padding: 8,
        cursor: 'not-allowed',
        opacity: 0.5
    }
}))

export const ButtonV2 = ({ children, onClick, disabled, style }) => {
    const theme = useSelector(state => state.main.theme)
    const classes = useStyles(theme)

    return (
        <div
            onClick={onClick}
            disabled={disabled}
            style={style}
            className={disabled ? classes.rootDisabled : classes.root}
        >
            {children}
        </div>
    )
}
